import React from 'react'
import { findOptionById, toMenuOptions, WemoloDropdown } from '../../../../../components/Wemolo'

interface Option {
    id: string
    label: string
}

interface CustomSelectProps {
    label: string
    options: Option[]
    value: Option
    onChange: (option: Option | null) => void
    disabled?: boolean
}

export const CustomSelect: React.FC<CustomSelectProps> = ({ label, options, value, onChange, disabled }) => {
    const valueId = value?.id
    const valueMissingFromOptions = valueId !== undefined && !options.some((o) => o.id === valueId)
    const lookupOptions = valueMissingFromOptions ? [{ id: valueId, label: value.label }, ...options] : options
    const menuOptions = toMenuOptions(lookupOptions)

    return (
        <WemoloDropdown
            label={label}
            size="medium"
            placeholder="Select…"
            options={menuOptions}
            value={valueId}
            onChange={(id) => onChange(findOptionById(lookupOptions, id) ?? null)}
            disabled={disabled}
        />
    )
}
